module.exports = __webpack_public_path__ + "img/99.1b1fa096.jpg";